<template>
    <div class="login" :style="{height:clientHeight,width:clientWidth}">
        <div class="login-container" style="padding-bottom: 30px">
            <el-form :model="loginForm" ref="loginForm" class="card-box login-form" >
                <h1 class="title" style="color: white"> 涵润堂</h1>
                <el-form-item prop="userName" class="item userItem" style="padding-right: 17px">
			        <span class="svg-container">
			        	<i class="fa fa-user-o" aria-hidden="true"></i>
			        </span>
                    <el-input name="userName" type="text" v-model="loginForm.userName" placeholder="用户名"
                              class="input-content"></el-input>
                </el-form-item>
                <el-form-item prop="password" class="item" style="padding-right: 17px">
			        <span class="svg-container">
			        	<i class="fa fa-lock" aria-hidden="true"></i>
			        </span>
                    <el-input name="password" type="password" @keyup.enter.native="handleLogin"
                              v-model="loginForm.password" placeholder="密码" class="input-content"></el-input>
                </el-form-item>
                <el-form-item style="padding-right: 17px">
                    <el-button type="primary" @click="handleLogin" class="button">登录</el-button>
                </el-form-item>
            </el-form>
        </div>
        <router-view></router-view>
    </div>
</template>
<style scoped>
    .login {
        background-image: url("../assets/img/login.jpg");
        background-size: 100% 100%;
    }

    .button {
        width: 82%;
        margin-left: 45px;

    }

.login .login-container {
    background-color: #444;
  position: relative;
  top: 35%;
  width: 22%;
  height: 300px;
  margin: 0 auto;
  text-align: center;
  border-radius: 5px;
  opacity: 0.7;
}


.login .login-container .title {
  position: relative;
  top: 20px;
  font-family: "华文行楷";
}

    .login .login-container .userItem {
        margin-top: 50px;
    }

    .login .login-container .item .svg-container {
        display: inline-block;
        width: 40px;
        text-align: center;
        color: #889aa4;
        font-size: 20px;
    }



.login .login-container .item .input-content {
  display: inline-block;
  height: 47px;
  width: 82%;
}

    .login .login-container a {
        color: #fff;
        text-decoration: none;
    }
</style>
<script>
import Home from "@/view/home";
import Hello from "@/view/home_content/hello";
import store from "./../store";

  export default {
    data() {
      return {
        clientHeight: '',
        clientWidth: '',
        loginForm: store.state.userInfo,
      };
    },
    mounted: function () {
      const that = this;
      that.clientHeight = `${document.documentElement.clientHeight}px`;
      that.clientWidth = `${document.documentElement.clientWidth}px`;
      window.onresize = function temp() {                     // 然后监听window的resize事件．在浏览器窗口变化时再设置下背景图高度．
        that.clientHeight = `${document.documentElement.clientHeight}px`;
        that.clientWidth = `${document.documentElement.clientWidth}px`;
      }
    },
    methods: {
      handleLogin: function () {
        //获取当前时间
        let date=new Date();
        let expiresDays=10;
        //将date设置为10天以后的时间
        date.setTime(date.getTime()+expiresDays*24*3600*1000);
        //将userId和userName两个cookie设置为10天后过期
        let data = {
          account: this.loginForm.userName,
          password: this.loginForm.password
        }
        this.$axios({
          url: '/api/user/login',
          method: 'POST',
          data: data
        }).then(res => {
          document.cookie="account="+data.account+';'+'expires='+date.toGMTString();
          document.cookie="password="+data.password+';'+'expires='+date.toGMTString();
          if (res.data.code == 200) {
            let resData = res.data.data;
            let name = resData.name;
            let token = resData.token;
            localStorage.token = resData.token;           //  添加 token
            localStorage.uid = resData.id;
            localStorage.idNumber = resData.idNumber;
            localStorage.roleId = resData.roleId;
            this.$store.commit('namechange', name);
            this.$axios({
              url: '/api/permission/userId/' + resData.id,
              method: 'GET'
            }).then(res => {
              let routerJson = res.data.data;
              this.$message({
                type: 'success',
                message: '登录成功'
              })
              this.$router.push({
                path: routerJson[0].index
              });
            }).catch(err => {
              console.log(err);
            });
          } else {
            this.$message({
              type: 'warning',
              message: '用户名或密码错误'
            })
          }
        }).catch(err => {
          console.log(err);
        });
      }
    },
    created(){
      let cookieArr = document.cookie.split(";");
      if(cookieArr[0] != ''){
        let account=cookieArr[0].split("=")[1];
        let password = cookieArr[1].split("=")[1];
        this.loginForm.userName = account;
        this.loginForm.password = password;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// login.vue?4798f85f